const map = {
	"./gpoxc-icon.svg": 86979,
	"./logo_1.svg": 71645,
	"./logo_10.svg": 12743,
	"./logo_11.svg": 25622,
	"./logo_12.svg": 66869,
	"./logo_13.svg": 41236,
	"./logo_2.svg": 25374,
	"./logo_3.svg": 45423,
	"./logo_4.svg": 51632,
	"./logo_5.svg": 42753,
	"./logo_6.svg": 37714,
	"./logo_7.svg": 41027,
	"./logo_8.svg": 83988,
	"./logo_9.svg": 5621,
	"./logo_fe.svg": 86067,
	"./logo_hxa.svg": 75549,
	"./logo_hxm.svg": 99097,
	"./logo_lcp.svg": 82177,
	"./logo_xa.svg": 1853,
	"./logo_xb.svg": 47678,
	"./logo_xc.svg": 10255,
	"./logo_xf.svg": 67922,
	"./logo_xh.svg": 49428,
	"./logo_xi.svg": 91413,
	"./logo_xn.svg": 64650,
	"./logo_xo.svg": 98843,
	"./logo_xp.svg": 96524,
	"./logo_xs.svg": 51871,
	"./logo_xv.svg": 1570
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21572;